import {AnswerTemplateDto} from "../../../../libs/answer-templates/feature/answer-templates/domain/dtos";

interface Adaptation {
  chat_id: string;
  template_id: number;
  text: string;
  companies: Array<string>;
  shortcut: string;
}

export function livechatTemplatesSaveEditAdapter(
  attendanceId: string,
  template: AnswerTemplateDto,
): Adaptation {
  return {
    chat_id: attendanceId,
    template_id: template.idAnswerTemplate,
    text: template.content,
    companies: template.companiesIds,
    shortcut: template.title,
  }
}
